import { jsx as _jsx } from "react/jsx-runtime";
import { TimelineDescriptionDotExam } from "./components/TimelineDescriptionDotExam";
import { TimelineDescriptionDotProcess } from "./components/TimelineDescriptionDotProcess";
export function TimelineDescription(_a) {
    var step = _a.step, data = _a.data;
    var isProcessTypeStep = step.type === "process";
    return isProcessTypeStep ? (_jsx(TimelineDescriptionDotProcess, { data: data, step: step })) : (_jsx(TimelineDescriptionDotExam, { data: data, step: step }));
}
